import { RouteRecordRaw } from 'vue-router';
import { EditTrainingPage } from '@/pages/training';

export const routeName = 'TreinamentosEditar';

export const route: RouteRecordRaw = {
  path: 'treinamentos/lista-treinamentos/:id/editar',
  name: routeName,
  component: EditTrainingPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Editar Treinamento',
    breadcrumbTrail: [
      { name: 'Treinamentos', path: '/treinamentos' },
      { name: 'Lista de Treinamentos', path: '/treinamentos/lista-treinamentos' },
      { name: 'Editar Treinamento' },
    ],
    permissions: [
      { action: 'update', subject: 'Training' },
      { action: 'readMatrix', subject: 'Training' },
    ],
  },
};
